import { getEnv } from '../helpers/EnvHelper';
export const ENABLE_WHATSAPP =
  getEnv("REACT_APP_ENABLE_WHATSAPP") === "true";
